import woltInstance from '../instance'

const storeWoltDriverDeliveryPromises = (data) => {
    return woltInstance.post('/driverIntegrations/deliveryPromises', data)
}

export default storeWoltDriverDeliveryPromises